<template>
  <div v-if="isInAppBrowser" class="browser-guide-overlay" @touchmove.prevent>
    <div class="guide-content">
      <v-icon size="80" color="white" class="arrow-icon">mdi-arrow-top-right</v-icon>

      <div class="text-content">
        <h3>請使用外部瀏覽器開啟</h3>
        <p>
          為了確保功能正常運作
          <br />
          <span class="d-flex align-center justify-center">
            請點擊右上角的
            <v-icon color="white" class="px-1">mdi-dots-horizontal</v-icon>
            或
            <v-icon color="white" class="px-1">mdi-dots-vertical</v-icon>
            圖示
          </span>
        </p>
        <p>
          並選擇
          <strong class="d-flex align-center justify-center">
            「
            <v-icon color="#ffca28" class="px-1">mdi-web</v-icon>
            使用外部瀏覽器開啟 」
          </strong>
          (Safari/Chrome)
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BrowserGuard",
  data() {
    return {
      isInAppBrowser: false,
    };
  },
  mounted() {
    this.checkUserAgent();
  },
  methods: {
    checkUserAgent() {
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      const isAndroid = /android/i.test(ua);
      const isFacebook = ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1;
      const isInstagram = ua.indexOf("Instagram") > -1;
      // LINE 通常不需要遮罩 (有 ?openExternalBrowser=1)，但如果你想統一體驗也可以加
      const isLine = ua.indexOf("Line") > -1;

      // 針對 FB, IG (視需求加入 Line)
      if (isFacebook || isInstagram) {
        if (isAndroid) {
          // Android: 先嘗試 Intent 跳轉
          const currentUrl = window.location.href;
          const cleanUrl = currentUrl.replace(/^https?:\/\//, "");
          const intentUrl = `intent://${cleanUrl}#Intent;scheme=https;package=com.android.chrome;end`;

          window.location.href = intentUrl;

          setTimeout(() => {
            this.isInAppBrowser = true;
          }, 1000);
        } else {
          // iOS: 直接顯示遮罩
          this.isInAppBrowser = true;
        }
      }
    },
  },
};
</script>

<style scoped>
.browser-guide-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.85);
  z-index: 9999;
  display: flex;
  justify-content: center;
  /* 預留空間給箭頭 */
  padding-top: 100px;
  color: #fff;
  font-family: "Microsoft JhengHei", sans-serif;
}

.guide-content {
  position: relative;
  text-align: center;
  width: 80%;
}

/* --- 箭頭定位與動畫 --- */
.arrow-icon {
  position: absolute;
  /* 定位到右上角 */
  top: -80px;
  right: 0px;
  /* 載入動畫 */
  animation: float-arrow 1.5s infinite ease-in-out;
}

/* 定義浮動動畫：讓箭頭往右上角指引的感覺更強烈 */
@keyframes float-arrow {
  0%,
  100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(10px, -10px); /* 往右上角移動一點 */
  }
}

.text-content h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #ffca28;
  font-weight: bold;
}

.text-content p {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 0.5rem;
}

.text-content strong {
  color: #ffca28;
  font-size: 1.2rem;
}
</style>
